import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export interface UseStylesParams {
  isMenuOpen: boolean;
}

export const useBalanceButtonStyles = makeStyles<UseStylesParams>()(
  (theme, { isMenuOpen }) => ({
    root: {
      flexShrink: 0,

      border: 'none',
      boxShadow: isMenuOpen
        ? `0 0 0 3px ${alpha(theme.palette.primary.main, 0.5)}`
        : undefined,

      backgroundColor: isMenuOpen
        ? theme.palette.grey[200]
        : theme.palette.background.paper,

      '&:hover': {
        backgroundColor: theme.palette.grey[200],
      },

      '&&': {
        padding: theme.spacing(0, 2),
      },
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    balance: {
      color: theme.palette.text.secondary,
      fontWeight: 500,
      fontSize: theme.spacing(3.5),
    },
    balanceValue: {
      color: theme.palette.text.primary,
    },
    selectIcon: {
      '&&': {
        color: theme.palette.text.secondary,
      },

      transition: 'transform 100ms',

      transform: isMenuOpen ? 'rotate(180deg)' : 'none',
      transformOrigin: '50% 50%',
    },
  }),
);
